import { notification } from 'antd'
import type { FormInstance } from 'antd/es/form'
import type { TFunction } from 'i18next'

import type { AxiosErrorType } from '@types'

export const DELIVERY_NOTE_NOT_IN_POSSIBLE_VALUES = 'Delivery note is not in possible values'

type TicketErrorResponse = {
  type: string
  status: number
  message: string
}

type NotifyTicketUpdateErrorOptions = {
  formInstance?: FormInstance
  noActiveRoutePreffix?: string
}

export const notifyTicketUpdateError = (
  err: unknown,
  t: TFunction,
  options: NotifyTicketUpdateErrorOptions = {},
) => {
  const error = err as AxiosErrorType
  const errorResponse = error?.data?.error as TicketErrorResponse | undefined

  if (!errorResponse?.message) {
    console.error('Error:', err)
    return
  }

  const { message, type } = errorResponse
  const tPreffix =
    options.noActiveRoutePreffix ?? 'suppliers_router.suppliers_dashboard.use_create_ticket.'

  if (type === 'NO_ACTIVE_ROUTE') {
    const hint =
      message.length > 62
        ? `${t(`${tPreffix}no_active_route_hint`)} ${message.substring(62, message.length)}`
        : `${t(`${tPreffix}no_active_route_at_all_hint`)}`

    notification.error({
      message: `${t(`${tPreffix}no_active_route`)} ${hint}`,
    })
    return
  }

  if (message === 'TicketSap already exists for this plantId') {
    const errorMessage = String(t(`globals.${message}`))
    notification.error({ message: errorMessage })
    options.formInstance?.setFields([
      {
        name: 'ticketSap',
        errors: [errorMessage],
      },
    ])
    return
  }

  if (message === DELIVERY_NOTE_NOT_IN_POSSIBLE_VALUES) {
    notification.warning({
      message: String(t(`globals.${message}`)),
    })
    return
  }

  notification.error({
    message: String(t([`globals.${message}`, 'globals.generics.generic_error'])),
  })
}
